import * as React from "react";

import { LeftMenuItem } from "../LeftMenuItem";
import { ExternalLinkItem } from "./ExternalLinkItem";
import { GroupItem } from "./GroupItem";
import { InternalLinkItem } from "./InternalLinkItem";

type PropsRenderLeftMenuItem2 = {
  item: LeftMenuItem;
  closeMenu: () => void;
};

export const RenderLeftMenuItem2: React.FC<PropsRenderLeftMenuItem2> = ({
  item,
  closeMenu,
}) => {
  if (item.hidden?.()) {
    return null;
  }
  // При наличии default компиялтор не будет оповещать о том, что при изменении type нужно обновить этот код
  // eslint-disable-next-line default-case
  switch (item.type) {
    case "link":
      return <InternalLinkItem item={item} onClick={closeMenu} />;
    case "external":
      return <ExternalLinkItem item={item} />;
    case "group":
      return <GroupItem item={item} closeMenu={closeMenu} />;
  }
  return null;
};
